import fetch from '../../utils/fetch'
//缴费
export function payParkingRecord(params) {
    return fetch({
        url: '/api/ticket/fixationParkingFeePayList',
        method: 'post',
        data: params
    })
}
